module.exports = __webpack_public_path__ + "static/media/IMG-8.db2a733f.jpg";